function getSignTypeDisplay(sign_type, electronic_signature = 'NO'){
    if (electronic_signature === 'YES') {
        return 'E_SIGNATURE'
    }else return sign_type;
}
export default getSignTypeDisplay;